import { cn } from 'lib/utils';
import Img from 'next/image';
import PropTypes from 'prop-types';

const RangeSelector = ({ ranges, selectedRangeId, handleRangeChange }) => {
  return (
    <div className="mb-1 flex gap-1 md:gap-0">
      {ranges.map((range) => (
        <button
          type="button"
          key={range.id}
          id={range.id}
          className={cn(
            'button-tab text-sm',
            selectedRangeId === range.id ? 'button-active' : ''
          )}
          onClick={handleRangeChange}
        >
          {range.icon ? (
            <Img
              src={range.icon}
              className="opacity-50 dark:invert"
              alt=""
              height="13"
              width="13"
            />
          ) : null}
          {range.label}{' '}
        </button>
      ))}
    </div>
  );
};

RangeSelector.propTypes = {
  ranges: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          src: PropTypes.string.isRequired,
        }),
      ]),
    })
  ).isRequired,
  selectedRangeId: PropTypes.string.isRequired,
  handleRangeChange: PropTypes.func.isRequired,
};

export default RangeSelector;
